module.exports = "/components/components/premiumPreviewRowComponent-4052a8.html";